import { useCallback } from "react";

import useDiscardRunShared from "shared/Run/useDiscardRun";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { SEARCH_PRIVATE_WORKER_POOL_SCHEDULABLE_RUNS } from "views/Account/PrivateWorkerPool/QueuedRuns/gql";
import { SEARCH_PUBLIC_WORKER_POOL_SCHEDULABLE_RUNS } from "views/Account/PublicWorkerPool/QueuedRuns/gql";

import { useModifyRunErrorHandler } from "./useModifyRunError";

const useDiscardRun = (isPublic?: boolean) => {
  const onError = useModifyRunErrorHandler();
  const { reportSuccess } = useTypedContext(FlashContext);

  const [discardRun, { loading }] = useDiscardRunShared({
    refetchQueries: [
      isPublic
        ? SEARCH_PUBLIC_WORKER_POOL_SCHEDULABLE_RUNS
        : SEARCH_PRIVATE_WORKER_POOL_SCHEDULABLE_RUNS,
    ],
    onError: onError,
  });

  const handleRunDiscard = useCallback(
    (stackId: string, runId: string) => {
      discardRun({ stack: stackId, run: runId, note: null }, (data) => {
        if (data?.runDiscard?.id) {
          reportSuccess({ message: `Run ${runId} was successfully discarded` });
        }
      });
    },
    [discardRun, reportSuccess]
  );

  return {
    discardRun: handleRunDiscard,
    discarding: loading,
  };
};

export default useDiscardRun;
